<script>
  import { getContext } from "svelte";
  import { Loader } from "@gl/design-system";

  import { user, language, contract, callout, url, Auth, _ } from "./stores/index";
  import { MicrofrontendError } from "./components/index";
  import { deriveMountedPath } from "./utils";
  import {
    loadMicrofrontendModule,
    waitForCustomElement,
  } from "./services/microfrontend";

  const BUNDLE_URL = "/content-manager-frontend/content-manager.js";

  const config = getContext("config");

  const authClass = new Auth(user, "content-manager");

  let attempt = 0;

  $: basePath = `/content-manager/contracts/${$contract?.id}`;
  let path;
  $: {
    const mounted = deriveMountedPath($url.pathname, $url.search, basePath);
    if (mounted) path = mounted.relative;
  }

  const load = async () => {
    if (!$user.apps?.some((app) => app.id === "content-manager")) return;

    // The container's bundle also loads the EU-P player (window.GlPlayer), so the
    // Access Manager no longer imports @gl/eup-player itself.
    await loadMicrofrontendModule(BUNDLE_URL, "content-manager");
    await waitForCustomElement("cm-element", "content-manager");
  };

  function retry() {
    attempt += 1;
  }
</script>

{#if $contract}
  {#key attempt}
    {#await load()}
      <div class="mfe-loading">
        <Loader />
        <span>
          {$_("microfrontend.loading", {
            values: { app: $_("content-manager") },
          })}
        </span>
      </div>
    {:then}
      <cm-element
        apiurl={config.API_URL}
        basepath={basePath}
        path={path}
        language={$language}
        contract={$contract}
        user={$user}
        isAuthorized={authClass}
        on:callout={(event) => callout.set(event.detail.callout)}
      />
    {:catch}
      <MicrofrontendError app="content-manager" on:click={retry} />
    {/await}
  {/key}
{/if}

<style>
  .mfe-loading {
    display: flex;
    gap: 12px;
    align-items: center;
  }
</style>
